interface JobChipProps {
  /** What the background job is doing, e.g. "Refining…" or "Drafting 14 of 32". */
  label: string;
  /** When present, renders a ✕ that abandons the client-side wait. */
  onCancel?: () => void;
  testId?: string;
}

/**
 * The ONE background-job progress chip (R7). A small spinner + a caller-formatted
 * label + an optional cancel. Reused by the non-blocking Refine here and (later,
 * EB4) by the bulk Draft-all / Assess-all runs — so "the AI is working" looks the
 * same everywhere. Accent-toned, theme-safe via tokens.
 */
export function JobChip({ label, onCancel, testId }: JobChipProps) {
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2 rounded-full bg-[var(--accent-soft)] px-2.5 py-1 text-xs font-medium text-[var(--accent-strong)]"
    >
      <span
        aria-hidden
        className="h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
      />
      {label}
      {onCancel ? (
        <button
          type="button"
          onClick={onCancel}
          aria-label="Cancel"
          className="-mr-0.5 ml-0.5 rounded px-1 text-current opacity-70 hover:opacity-100"
        >
          ✕
        </button>
      ) : null}
    </span>
  );
}
